import rill from "rill";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { getRoleNameById } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import automationBuilderController from "./automation-builder.controller";
import customWorkflowsController from "./custom-workflows.controller";

const CustomWorkflows = (app) => {
  app.at(
    "/custom-workflows/*",
    rill().setup((app) => {
      // Admins and owners always; anyone else needs the Custom Workflows permission
      const guard = (ctx, next) => {
        const { activeUser, organizationRoles } = ctx.locals;
        const roleName = activeUser.organizationRoleId
          ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
          : "Owner";
        const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";
        if (isAdminOrOwner) return next();

        return checkOrganizationSectionPermission(
          ctx,
          next,
          ["Custom Workflows"],
          "/coaching-portal/athletes"
        );
      };
      app.get("/", guard, customWorkflowsController);
      app.get("/automations/:id", guard, automationBuilderController);
    })
  );
};

export default CustomWorkflows;
